// Formatted to yyy-MM-dd
import stringUtils from "./string-utils";

const getFirstDayOfNextMonth = (today) => {
    if (typeof today === "string") {
        today = new Date(today);
    }
    const nextMonth = today.getMonth() + 1;
    const year = today.getFullYear() + (nextMonth === 12 ? 1 : 0);
    return new Date(year, nextMonth % 12, 1);
};

const getFirstDayOfCurrentMonth = (currentMonth) => {
    if (typeof currentMonth === "string") {
        currentMonth = new Date(currentMonth);
    }

    currentMonth.setDate(1);
    return currentMonth;
};

const formatDateByDateString = (dateString, attachYear) => {
    if (dateString === null) {
        return "";
    }
    const d = new Date(dateString);
    let formattedDateString = ("0" + d.getDate()).slice(-2) + "." + ("0" + (d.getMonth() + 1)).slice(-2);
    if (attachYear) {
        formattedDateString += "." + d.getFullYear();
    }
    if (formattedDateString === "01.01.1970" || formattedDateString === "0000-00-00") {
        formattedDateString = "";
    }
    return formattedDateString;
};

const formatDateToDDMMYY = (dateString) => {
    if (stringUtils.isBlank(dateString)) {
        return "";
    }
    if (dateString.length === 10) {
        const dayAndMonth = dateString.substring(0, dateString.length - 4);
        const year = dateString.substring(dateString.length - 2, dateString.length);
        return dayAndMonth + year;
    } else {
        return dateString;
    }
};

const formatDateByValues = (day, month, year) => {
    let result = year;
    if (month > 9) {
        result = result + "-" + month;
    } else {
        result = result + "-0" + month;
    }

    if (day > 9) {
        result = result + "-" + day;
    } else {
        result = result + "-0" + day;
    }
    return result;
};

const formatDateTime = (date) => {
    if (!date) {
        return "";
    }
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let strTime = hours + ":" + minutes + " " + ampm;
    return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() + " " + strTime;
};

const getYears = (from, to) => {
    let list = [];
    while (to >= from) {
        list.push(to);
        to--;
    }
    return list;
};

const getMonths = () => {
    return [
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember",
    ];
};

// Check where it's used and adjust to calculateLast
const getLastDayOfMonth = (year, month) => {
    let d = new Date();
    d.setFullYear(year, month + 1, 0);
    return d.getDate();
};

const getLastDayOfMonthDate = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};

const getLastMonth = () => {
    return getPreviousMonth(new Date());
};

const getFirstDayOfLastMonth = () => {
    let date = new Date(new Date().setDate(0));
    date.setDate(1);
    return date.toISOString().split("T")[0];
};

const formatDateYYYYMMdd = (date) => {
    let year = date.toLocaleString("default", { year: "numeric" });
    const month = date.toLocaleString("default", { month: "2-digit" });
    const day = date.toLocaleString("default", { day: "2-digit" });

    while (year.length < 4) {
        year = "0" + year;
    }

    return year + "-" + month + "-" + day;
};

const formatToGermanDateString = (date, shortYear) => {
    if (!date || date === "") {
        return "";
    }
    if (typeof date === "string") {
        date = new Date(date);
    }
    return date.toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: shortYear ? "2-digit" : "numeric",
    });
};

const formatToGermanTimeString = (date, includeSeconds = true) => {
    if (!date || date === "") {
        return "";
    }
    if (typeof date === "string") {
        date = new Date(date);
    }
    return date.toLocaleTimeString("de-DE", {
        hour: "2-digit",
        minute: "2-digit",
        second: includeSeconds ? "2-digit" : undefined,
    });
};

const formatToGermanDateTimeString = (date, includeSeconds = true) => {
    return formatToGermanDateString(date) + " - " + formatToGermanTimeString(date, includeSeconds);
};

const formatToYearMonthString = (year, month) => {
    const date = new Date(year, month, 1);
    const yearString = date.toLocaleString("default", { year: "numeric" });
    const monthString = date.toLocaleString("default", { month: "2-digit" });
    return yearString + "-" + monthString;
};

const isValidDate = (date) => {
    return date && new Date(date) && (isNaN(date) || !isNaN(new Date(date)));
};

const getNextMonth = (date) => {
    let d = new Date(date);
    d.setMonth(d.getMonth() + 1);
    return d;
};

const getPreviousMonth = (date) => {
    let d = new Date(date);

    const currentDay = d.getDate();
    const validLastDayOfLastMonth = new Date(d.getFullYear(), d.getMonth(), 0).getDate();

    // if month's date value exceeds the valid last day, date value will be the valid last day
    // eg. 31.03, this will get 28.02 instead of 31.02 which JS automatically changed to 03.03 as 31.02 is not valid
    d.setDate(Math.min(currentDay, validLastDayOfLastMonth));
    d.setMonth(d.getMonth() - 1);
    return d;
};

const isBefore = (a, b) => {
    if (typeof a === "string") {
        a = new Date(a);
    }
    if (typeof b === "string") {
        b = new Date(b);
    }

    return (
        a.getFullYear() < b.getFullYear() ||
        (a.getFullYear() === b.getFullYear() && a.getMonth() < b.getMonth()) ||
        (a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() < b.getDate())
    );
};

const isAfter = (a, b) => {
    if (typeof a === "string") {
        a = new Date(a);
    }
    if (typeof b === "string") {
        b = new Date(b);
    }

    return (
        a.getFullYear() > b.getFullYear() ||
        (a.getFullYear() === b.getFullYear() && a.getMonth() > b.getMonth()) ||
        (a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() > b.getDate())
    );
};

const isSameDay = (a, b) => {
    if (typeof a === "string") {
        a = new Date(a);
    }
    if (typeof b === "string") {
        b = new Date(b);
    }

    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
};
const isSameMonth = (a, b) => {
    if (typeof a === "string") {
        a = new Date(a);
    }
    if (typeof b === "string") {
        b = new Date(b);
    }

    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();
};

const parseZonelessDate = (dateString) => {
    let date = new Date(dateString);
    let userTimezoneOffset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() + userTimezoneOffset);
};

const getDurationBetween = (date1, date2) => {
    let totalSeconds = (date2.getTime() - date1.getTime()) / 1000;
    let seconds = totalSeconds % 60;
    let totalMinutes = Math.abs(Math.floor(totalSeconds / 60));
    let minutes = totalMinutes % 60;
    let totalHours = Math.abs(Math.floor(totalMinutes / 60));
    let hours = totalHours % 24;
    let totalDays = Math.abs(Math.floor(totalHours / 24));
    return {
        seconds: seconds,
        minutes: minutes,
        hours: hours,
        days: totalDays,
    };
};

const getDurationBetweenInMs = (date1, date2) => {
    const duration = getDurationBetween(date1, date2);
    return (((duration.days * 24 + duration.hours) * 60 + duration.minutes) * 60 + duration.seconds) * 1000;
};

const dateUtils = {
    getFirstDayOfNextMonth,
    getFirstDayOfCurrentMonth,
    formatDateByDateString,
    formatDateToDDMMYY,
    formatDateByValues,
    formatDateTime,
    getYears,
    getMonths,
    getLastDayOfMonth,
    getLastDayOfMonthDate,
    getLastMonth,
    formatDateYYYYMMdd,
    formatToGermanDateString,
    formatToGermanTimeString,
    formatToGermanDateTimeString,
    formatToYearMonthString,
    isValidDate,
    getFirstDayOfLastMonth,
    getNextMonth,
    getPreviousMonth,
    isBefore,
    isAfter,
    isSameDay,
    isSameMonth,
    parseZonelessDate,
    getDurationBetween,
    getDurationBetweenInMs,
};

export default dateUtils;
